<finder-section
    class="accordion"
    (click)="clicked($event, EVENTS.CATEGORY, title.id)"
    (keydown.enter)="clicked($event, EVENTS.CATEGORY, title.id)"
    [sync]="true"
    [id]="title.id"
    *ngFor="let title of data"
    [icons]="title.icons"
    [labels]="title.labels">
    <div
        role="button"
        tabindex="-1"
        (click)="clicked($event, EVENTS.LIST_ITEM, listItem.id)"
        class="location"
        (keydown.enter)="clicked($event, EVENTS.LIST_ITEM, listItem.id)"
        *ngFor="let listItem of title.listItems"
        [id]="listItem.id">
            <finder-font-icon class="list-icon" *ngIf="listItem.icon" size="l" [name]="listItem.icon"></finder-font-icon>
            <span>{{listItem.name}}</span>
            <finder-font-icon class="caret" size="s" svg="true" name="next-2"></finder-font-icon>
    </div>
</finder-section>
